import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { CameraSliceTypes, createCameraSlice } from './createCameraSlice';
import createSelectors from './createSelectors';
import { createSessionSlice, SessionSliceTypes } from './createSessionSlice';
import { createSitesSlice, SitesSliceTypes } from './createSitesSlice';
import { createUserSlice, UserSliceTypes } from './createUserSlice';

export type RemoteBoundStoreState = UserSliceTypes &
  CameraSliceTypes &
  SessionSliceTypes &
  SitesSliceTypes;

const useRemoteBoundStoreBase = create<RemoteBoundStoreState>()(
  immer(
    devtools((...a) => ({
      ...createUserSlice(...a),
      ...createCameraSlice(...a),
      ...createSessionSlice(...a),
      ...createSitesSlice(...a),
    })),
  ),
);

const useRemoteBoundStore = createSelectors(useRemoteBoundStoreBase);

export default useRemoteBoundStore;
